'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Eraser';

var EntypoEraser = function EntypoEraser(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M16.998,4.18l-3.154-2.425c-0.872-0.671-2.135-0.506-2.807,0.365l-8.4,10.897c-0.671,0.871-0.507,2.132,0.365,2.803l3.153,2.425c0.872,0.671,2.135,0.506,2.807-0.365l8.401-10.897C18.034,6.112,17.87,4.851,16.998,4.18z M8.548,16.467l-0.537,0.681c-0.152,0.197-0.385,0.31-0.639,0.31c-0.124,0-0.309-0.029-0.485-0.164l-3.153-2.425c-0.168-0.129-0.275-0.317-0.303-0.53c-0.028-0.213,0.028-0.422,0.157-0.589l0.537-0.681c0.152-0.197,0.385-0.311,0.64-0.311c0.124,0,0.309,0.029,0.485,0.164l3.154,2.425c0.168,0.129,0.275,0.317,0.303,0.53C8.733,16.09,8.677,16.299,8.548,16.467z' })
    );
};

exports.default = EntypoEraser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/Eraser.js
// module id = ./node_modules/react-entypo/lib/entypo/Eraser.js
// module chunks = 2